import React from 'react'

export default () => {
    return (
        <style js="true">
            {`

.req-msg
     {
    width: 319px!important;
    margin-left: 6%!important;
    margin-top: 9px;
    margin-bottom: 3rem;
    color: Red;
    font-size: 16px;
    }
 .container-all{
                
                box-shadow: 0 0 10px;
            }
            .row.section1-row.d-flex.justify-content-around {
                box-shadow: 0px 0px 5px;
            }
            .section2
            {
             margin-bottom: 147px;
            }
            .row.space-between {
                display: flex;
                justify-content: space-around;
                padding-bottom: 1%;
            }


            .chat1-inside-data
            {
            display:flex;
            height: 105px!important;
    background: #035F80!important;
    border-radius: 180px;
    max-width: 669px;

    text-align: justify;
    padding: 10px;
    line-height: 30px;
    font-size: 20px;
    text-align: whi;
    color: white;
               }
 .chat-inside-data {
    height: 85px;
}
             .chat1 {
                padding-left: 3%;
                padding-top: 2%;
                    }
            .Loader {
                padding-left: 3%;
                width: 180px;
                height: 80px;
                background: #F37F00;
                border-radius: 50px;
            }
            .chat-input-data {
            text-align: justify;
            font-size: 23px;
                float: right;
                background: #F37F00 ;
              // width: 42%;
               height: 105px!important;
                border-radius: 55px;
               //min-width: 39%;

            }

            // p.p {
            //
            //     font-size: 22px;
            //     margin-left: 0px!important;
            //
            // }
            .input{
                height: 65px;
    border-radius: 7px;
    background: #e7efff;
    font-size: 22px;
    width: 300px;
    padding-left: 6px;
    margin-top: 22px;
            }
            .button{
            margin-top: 23%!important;
    margin-right: 16px;
    margin-bottom: 10px;
    border-radius: 10px;
    width: 80px;
    height: 63px;
               }
            button:disabled,
button[disabled]{
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #f49226;
}

            .button:hover {
  background-color: #f49226;
}


            .chat-input {
                padding-bottom: 127px;
            }

            .chat-input2 {
                padding-bottom: 127px;
            }
            .chat-input-data2 {
           float: right;
    background: #006a90;
    width: 662px;

    border-radius: 55px;
}
    .sub-input{
   font-size: 23px;
    width: 509px;
    margin-left: -5px;
    margin-top: -15px;
    }
.chat-input-data2 .btn{
     margin-left: 32px;
    margin-top: 14%!important;
    width: 80px;
    height: 63px;
    background: #F37F00;
            
            }


  .sub-input  a:hover {
    color: white !important;
    text-decoration: underline;
}
            `}
        </style>
    );
}